export default "__VITE_ASSET__XV3uUyAv__"